import {Component, EventEmitter, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";
import {Store} from "@ngrx/store";
import {AppState} from "../../store";
import {FavoritesService} from "../favorites.service";

@Component({
  selector: 'brt-remove-list-dialog',
  templateUrl: './remove-list-dialog.component.html',
  styleUrls: ['./remove-list-dialog.component.scss']
})
export class RemoveListDialogComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  inProcess = false;

  constructor(private store: Store<AppState>, private favorites: FavoritesService) {
  }
  confirm() {
    if(!this.inProcess) {
      this.inProcess = true;
      this.favorites.removeFavorites().then(() => {
        this.onClosed.emit(true);
      });
    }
  }
}
